import { useEffect, useState } from 'react'
import { StringParam, useQueryParams } from 'use-query-params'

import { isServiceSortField, parseServiceListQuery } from './serviceListQuery'

const PAGE_SIZE = 25

/**
 * The services list's search and sort, kept in the URL so a link, a reload or the back button keeps them.
 * Clicking the sorted column again flips its direction; another column starts ascending.
 */
export function useServiceListQuery() {
  const [params, setParams] = useQueryParams({ search: StringParam, sort: StringParam, direction: StringParam })
  const { sort, direction, search } = parseServiceListQuery(params)
  const [searchValue, setSearchValue] = useState(search ?? '')

  useEffect(() => {
    setSearchValue(search ?? '')
  }, [search])

  const requestSort = (column: string) => {
    if (!isServiceSortField(column)) return

    setParams({ sort: column, direction: column === sort && direction === 'ASC' ? 'DESC' : 'ASC' })
  }

  return {
    apiParams: { sort, direction, pageSize: PAGE_SIZE, ...(search && { search }) },
    sort,
    direction,
    requestSort,
    searchValue,
    setSearchValue,
    submitSearch: (value: string) => setParams({ search: value.trim() || undefined }),
    clearSearch: () => {
      setSearchValue('')
      setParams({ search: undefined })
    }
  }
}
